import * as React from 'react';
import BaseComponent from '../BaseComponent';
import {Button, Card, CardBody, CardHeader, Col, Modal, Row} from "reactstrap";
import * as PropTypes from 'prop-types';
// import label from "../../message/Label"
import label from 'enqc-utilities/src/label/Label'

import inspectionImage from '../../assets/img/banner/inspection.png'
import HorizontalLine from "../Widget/HorizontalLine";
import MyCardImage from "../Card/MyCardImage";
import ModalCardHeader from "../Widget/ModalCardHeader";

/*= (message, okCallback, cancelCallback) =>*/
export default class ContinueReleaseVerificationConfirmModal extends BaseComponent{



    render(){
        let {show, releaseVerification} = this.props
        if(!releaseVerification){
            releaseVerification = {}
        }
        let model = releaseVerification.model??{}
        return (
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    size="md"
                    centered={true}
                    isOpen={show}
                    backdrop={true}>
                    <Card style={{textAlign:'center'}}>
                        <ModalCardHeader content={<span className="h2 text-uppercase font-weight-bolder">{label.ReleaseVerification}</span>}/>
                        <CardBody>
                            <Row>
                                <Col>
                                    <MyCardImage style={{padding:'32px', width:'80%'}} src={inspectionImage}/>
                                </Col>
                            </Row>
                            <HorizontalLine/>
                            <Row>
                                <Col>
                                    <h3>
                                        <strong>
                                            {model.systemType}
                                        </strong>
                                    </h3>
                                    <br/>
                                    <h5>{label.Reference}</h5>
                                    <br/>
                                    <h3>
                                        <strong>
                                            {releaseVerification.reference}
                                        </strong>
                                    </h3>
                                    <br/>
                                    <strong style={{color:'brown'}}>
                                        {label.DoYouWantToContinueVerificationProcess}
                                    </strong>
                                </Col>
                            </Row>
                            <HorizontalLine/>
                            <Row>
                                <Col style={{textAlign:'left'}}>
                                    <Button
                                        block
                                        color={"danger"}
                                        onClick={() => {
                                            this.props.onClickCancel()
                                        }}>
                                        {label.Cancel}
                                    </Button>
                                </Col>
                                <Col style={{textAlign:'right'}}>
                                    <Button
                                        block
                                        onClick={() => {
                                            this.props.onClickOk(releaseVerification)
                                        }}>
                                        {label.ContinueVerification}
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Modal>
            </>
           )
    }
}

ContinueReleaseVerificationConfirmModal.propTypes = {
    show:PropTypes.bool.isRequired,
    onClickOk:PropTypes.func.isRequired,
    onClickCancel:PropTypes.func.isRequired,
    releaseVerification:PropTypes.object.isRequired,
}
